import { FormlyFieldConfig } from '@ngx-formly/core';
import { EIremboFormlyFieldTypes } from '@irembo-andela/irembogov3-common';
import {
  IFormbuilderFieldTypeConfiguration,
  ICustomChildNidConfigurationFormModel,
} from '../../../models/form-builder-types-configurations.model';
import {
  baseFieldUpdateFromSettingsFormModel,
  populatesPropsParseIntoSettingsFormModel,
  populatesPropsUpdateFromSettingsFormModel,
} from '../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import { IFormFieldsValidationModel } from '../../../models/form-fields-formly-validation.model';
import {
  parsePopulatesFieldValidatorFormDataIntoModel,
  parseRequiredValidatorParseFieldIntoModel,
} from '../form-fields-formly-validations/form-fields-formly-validation-field-parse-to-model.util';
import {
  setRequiredValidatorUpdateFieldFromModel,
  setPopulatesFieldValidatorFormDataIntoField,
} from '../form-fields-formly-validations/form-fields-formly-validation-field-set-from-model.util';
import { FormBuilderService } from '../../../services/form-builder.service';
import { IFormFieldsDisplayModel } from '../../../models/form-fields-formly-display.model';
import { parseFieldIntoDisplayFormModel } from '../form-fields-formly-display/form-fields-formly-display-field-parse-to-model.util';
import { setDisplayHideExpressionFromModel } from '../form-fields-formly-display/form-fields-formly-display-field-set-from-model.util';
import { getGenericCustomIdFieldTypeconfigurationConfig } from './shared.configuration';
import { nidChildNidResponseProps } from '../../../models/custom-id-input-responses.model';

export const childNidFieldGetConfigurationConfig = (
  formBuilderServiceInstance: FormBuilderService
): IFormbuilderFieldTypeConfiguration => {
  const config = getGenericCustomIdFieldTypeconfigurationConfig(
    formBuilderServiceInstance,
    [...Array.from(nidChildNidResponseProps)]
  );

  config.settings.formlyForm = [
    ...config.settings.formlyForm,
    ...getChildNidFieldSettingsConfig(),
  ];

  return config;
};

export const getChildNidFieldSettingsConfig = (): FormlyFieldConfig[] => {
  return [
    {
      key: 'childNidFieldContentConfig',
      id: 'childNidFieldContentConfig',
      type: EIremboFormlyFieldTypes['formly-group'],
      props: {
        dragDisabled: false,
      },
      fieldGroup: [
        {
          key: 'mixpanelEventAnalytics',
          type: EIremboFormlyFieldTypes.checkbox,
          defaultValue: false,
          props: { label: 'Enable MixPanel Analytics', formCheck: 'switch' },
        },
      ],
    },
  ];
};

export const childNidParseIntoSettingsFormModel = (
  childNidField: FormlyFieldConfig
): ICustomChildNidConfigurationFormModel => {
  const model: ICustomChildNidConfigurationFormModel =
    populatesPropsParseIntoSettingsFormModel(childNidField);

  model.childNidFieldContentConfig = {
    mixpanelEventAnalytics: childNidField.props?.['mixpanelEventAnalytics'],
  };

  return model;
};

export const childNidUpdateFromSettingsFormModel = (
  model: ICustomChildNidConfigurationFormModel,
  childNidField: FormlyFieldConfig
): FormlyFieldConfig => {
  childNidField = baseFieldUpdateFromSettingsFormModel(model, childNidField);
  childNidField = populatesPropsUpdateFromSettingsFormModel(
    model,
    childNidField
  );

  const childNidFieldProps: Record<string, any> = childNidField?.props
    ? { ...childNidField?.props }
    : {};
  childNidFieldProps['mixpanelEventAnalytics'] =
    model.childNidFieldContentConfig?.mixpanelEventAnalytics;

  childNidField.props = { ...childNidFieldProps };

  return childNidField;
};

export const childNidParseIntoValidationFormModel = (
  childNidField: FormlyFieldConfig
): IFormFieldsValidationModel => {
  let model: IFormFieldsValidationModel = {};

  model = parseRequiredValidatorParseFieldIntoModel(model, childNidField);
  model = parsePopulatesFieldValidatorFormDataIntoModel(model, childNidField);

  return model;
};

export const childNidUpdateFromValidationFormModel = (
  model: IFormFieldsValidationModel,
  childNidField: FormlyFieldConfig
): FormlyFieldConfig => {
  childNidField = setRequiredValidatorUpdateFieldFromModel(
    model,
    childNidField
  );
  childNidField = setPopulatesFieldValidatorFormDataIntoField(
    model,
    childNidField
  );

  return childNidField;
};

export const childNidParseFieldIntoDisplayFormModel = (
  childNidField: FormlyFieldConfig
): IFormFieldsDisplayModel => {
  return parseFieldIntoDisplayFormModel(childNidField);
};

export const childNidUpdateFromDisplayFormModel = (
  model: IFormFieldsDisplayModel,
  childNidField: FormlyFieldConfig
): FormlyFieldConfig => {
  return setDisplayHideExpressionFromModel(model, childNidField);
};
